<template>
  <div class="container-fluid">

  <div class="d-none d-lg-flex pt-5 row full-height">
    <div class="d-none d-lg-block col-md-3">
      <side-menu :showInfoTv="showInfoTv" :tv="currTv" :currentProgram="infoCurrentProgram" :futureProgram="futureProgram"/>
    </div>
    
    <div class="col-lg-9 col-md-12">
        <div class="row d-flex align-items-stretch justify-content-center w-100">
          <div class="col-md-5 text-left">
            <div class="row">
              <div class="col-3">
                <img src="../assets/images/icona_live_tv.png" class="img-fluid"  > 
              </div>
              <div class="col pt-4">
                <span class="text-white mt-2" id="text_logo">LIVE TV</span><br>
                <span id="text">Canali in Streaming</span>
              </div>
              <div class="d-md-none d-dm-flex col-2 pt-5">
                <a :href="this.backlink">
                  <figure class="figure">
                      <img src="../assets/images/go_back_icon.png" class="img-fluid"> 
                      <figcaption class="figure-caption text-white">BACK</figcaption>
                  </figure>
                </a>
              </div>
            </div>

          </div>
          <div class="d-md-flex col-md-7 align-items-center justify-content-end">
            <div class="w-100">
              <search :back="true" :backlink="this.backlink" :callbackSearch="callbackSearch"></search>  
            </div> 
          </div> 
          
        </div>
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb defaut-color pt-5">
            <li class="breadcrumb-item"><router-link to="/"><strong>Home</strong></router-link></li>
            <li class="breadcrumb-item"><router-link to="/search-territorio"><strong>Regioni</strong></router-link></li>
            <li class="breadcrumb-item"><router-link  :to="'/search-province/'+this.$route.params.regione "><strong>{{this.$route.params.regione}}</strong></router-link></li>
            <li class="breadcrumb-item active text-white" aria-current="page"><strong>{{this.$route.params.provincia}}</strong></li>
          </ol>
        </nav>
        <div class="row pt-5">
          <div class="col-md-5 align-items-start">
            <div v-for="(item, index) in tv" v-bind:key="item.search_key">
            <div class="col-md-12" v-if="index <= 4" @mouseover="mouseOver(item)" @mouseout="mouseOut()">
                <router-link :to="`/show/${item.search_key}`">
                  <tv-card :images="item.imageSmallUrl" :sigla="item.sigla" :number="item.numero" ></tv-card>
                  
                </router-link>
                </div>                
            </div>
          </div>
          <div class="col-md-1"></div>
          <div class="col-md-5">
            <div v-for="(item, index) in tv" v-bind:key="item.search_key">
              <div class="col-md-12"  v-if="index > 4">
                  <router-link class="tv-link" :to="`/show/${item.search_key}`" >
                    <tv-card :images="item.imageSmallUrl" :sigla="item.sigla" :number="item.numero"></tv-card>
                    
                  </router-link>
                </div>
            </div>
          </div>
        </div>
        <footer class="navbar footer fixed-bottom-20 navbar-trasparent text-center px-5">
          <main-footer />
        </footer>
      </div>
    </div>

    <!-- MOD. RESPONSIVE -->

    <div class="row pt-4 d-lg-none d-md-flex" style="height:700px;">
      <div class="col-12">
      <div class="row d-flex align-items-stretch justify-content-center">
          <div class="col-md-12 align-items-center justify-content-end pb-3">
            <search :back="true" :backlink="this.backlink"></search>   
          </div>
          <div class="col-md-12 text-left">
            <div class="row align-items-center">
              <div class="pl-3">
                <img src="../assets/images/icona_live_tv_sm.png" class="img-fluid"  > 
              </div>
              <div class="col pt-2">
                <span class="text-white" id="text_logo">LIVE TV</span><br>
                <span id="text">Canali in Streaming</span>
              </div>
            </div>
          </div>
        </div>

        <nav aria-label="breadcrumb">
          <ol class="breadcrumb defaut-color pt-5">
            <li class="breadcrumb-item" style="padding-left:0!important;"><router-link to="/"><strong>Home</strong></router-link></li>
            <li class="breadcrumb-item" style="padding-left:0px!important;"><router-link to="/search-territorio"><strong>Regioni</strong></router-link></li>
            <li class="breadcrumb-item" style="padding-left:0!important;"><router-link  :to="'/search-province/'+this.$route.params.regione "><strong>{{this.$route.params.regione}}</strong></router-link></li>
            <li class="breadcrumb-item active text-white" style="padding-left:0!important;" aria-current="page"><strong>{{this.$route.params.provincia}}</strong></li>
          </ol>
        </nav>
        <div class="row pt-5">
          <div class="col-md-5 align-items-start">
            <div v-for="(item, index) in tv" v-bind:key="item.search_key">
            <div class="col-md-12" v-if="index <= 4" @mouseover="mouseOver(item)" @mouseout="mouseOut()">
                <router-link :to="`/show/${item.search_key}`">
                  <tv-card :images="item.imageSmallUrl" :sigla="item.sigla" :number="item.numero" ></tv-card>
                  
                </router-link>
                </div>                
            </div>
          </div>
          <div class="col-md-1"></div>
          <div class="col-md-5">
            <div v-for="(item, index) in tv" v-bind:key="item.search_key">
              <div class="col-md-12"  v-if="index > 4">
                  <router-link class="tv-link" :to="`/show/${item.search_key}`" >
                    <tv-card :images="item.imageSmallUrl" :sigla="item.sigla" :number="item.numero"></tv-card>
                    
                  </router-link>
                </div>
            </div>
          </div>
        </div>
      </div>
      <footer class="navbar footer navbar-trasparent text-center pt-5 px-5">
          <main-footer />
      </footer>
    </div>      
  </div>  
</template>

<script>
// @ is an alias to /src

import TvCard from '@/components/TvCard.vue'
import Tv from '../api/tv.js';
import SideMenu from '@/components/SideMenu.vue'
import Epg from '../models/Epg.js';
import Search from '@/components/Search.vue'
import MainFooter from '@/components/MainFooter.vue'
//import { mapState, mapActions, mapGetters } from 'vuex'
import { mapState } from 'vuex'

export default {
  name: 'list',
  data: function() {
    return  {
      tv: [],
      backlink: "javascript:history.go(-1)",
      currTv: {
          imageUrl: "",
          sigla: "",
          numero: "",
          favorite: false,
        },
      infoCurrentProgram: {
          descrizione: "",
          start: "",
          end: "",
          title: ""
        },
      futureProgram: [], 
      showInfoTv: false 
    };
  },
  components: {
    TvCard,SideMenu,Search,MainFooter
  },
  computed: {    
    ...mapState({
        user: state => state.User
    }),
    tvProvince: function ()  {
      return this.user.tvTerritorio;
    }
  },
  methods: {
      callbackSearch(searchKey) {
        //console.log("callbackSearch",searchKey);
        this.tv = [];
        let apiTv = new Tv();
        apiTv.getSearchTv(searchKey)
          .then(response => {
            //console.log(response.data)
            if(response.data) {
              this.tv = response.data;
            } else {
              //console.log("Nessun dato ricevuto");
            }
          })
          .catch(function (error) {
                console.log(error);                       
          }); 
      }, 
      mouseOver(item) {    
        this.showInfoTv = true;
        let epg = new Epg(item);
        this.currTv = item;
        this.futureProgram = epg.getFutureProgram();
        this.infoCurrentProgram = epg.getCurrentProgram();
      },
      mouseOut() { 
        this.showInfoTv = false;        
      },
  },
  created: function() {
      this.backlink = window.history.state == null ? "/" : this.backlink;
      let provincia = this.$route.params.provincia;
      let apiTv = new Tv();
      apiTv.getTvByProvincia(provincia)
        .then(response => {
          //console.log(response.data)
          if(response.data) {
            this.tv = response.data;
          } else {
            console.log("Nessun dato ricevuto");
          }
        })
        .catch(function (error) {
              console.log(error);                       
        });

  }
}
</script>

<style scoped lang="scss">

#text_logo{
    font-weight:bold;
    font-size:36px;
}

#text{
  font-size:20px;
  font-weight:normal;
  color: #ddd;
}


</style>